import angular from "angular";
import storeAccountManagementTemplate from './storeAccountManagement.html';

export const storeAccountManagementComponent = {
  controller: MainController,
  template: storeAccountManagementTemplate
};

/**
 * @ngdoc  controller
 * @module StoreAccountManagement
 * @name   StoreAccountManagement.StoreAccountManagement.controller:MainController
 * @description
 * This provides access to add individuals to the web store accounts and reset
 * passwords for accounts that are already created.
 */
/* @ngInject */ function MainController($injector, SERVER, $rootScope) {
  var $ctrl = this;
  $ctrl.orgHasCWS = SERVER.orgHasCWS;
  $ctrl.addEntity = $injector.invoke(addEntity, null, { $ctrl: $ctrl });
  $ctrl.commit = $injector.invoke(commit, null, { $ctrl: $ctrl });
  $ctrl.resetPassword = $injector.invoke(resetPassword, null, {
    $ctrl: $ctrl
  });

  $ctrl.instructions = $ctrl.orgHasCWS
    ? `Use this application to manage the accounts for your community web store.
    The list shows all current logins. Clicking the indicator will reset the 
    password and email the user.`
    : `Use this application to manage the accounts for your web store. 
    The list on the left shows all current logins, clicking the 
    indicator will reset the password and email the user. The list on the 
    right are all other individuals without a login. Clicking on their 
    icon will register them with a web store account.`;

  /*--------------------------------------------------------------*/
  /* Set the size of the logins grid. Initially I used ng-class   */
  /* to set this, but I found that was causing intermittent       */
  /* issues with the User Name and the reset password columns     */
  /* being rendered on the page. This seems to fix that issue. KS */
  /*--------------------------------------------------------------*/
  angular
    .element(document.querySelector('#loginsGrid'))
    .addClass($ctrl.orgHasCWS ? 'col-sm-12' : 'col-sm-8');

  $injector.invoke(init, null, { $ctrl: $ctrl });

  /***************************************************************************
   * addEntity
   **
    * Add the selected available individual to the store logins.
    *
    * @params entity  Selected entity
    ***************************************************************************/
  /* @ngInject */ function addEntity($ctrl, addEmailAddressDialog) {
    return function (entity) {
      if (!entity) return;

      /*-----------------------------------------------------------*/
      /* If the entity already has an email address call the       */
      /* commit function, otherwise open the addEmailAddressDialog */
      /* so the user can add an email address.                     */
      /*-----------------------------------------------------------*/
      if (!entity.email) {
        addEmailAddressDialog.show(entity).then(function (entity) {
          $ctrl.commit(entity);
        });
      } else $ctrl.commit(entity);
    };
  }

  /***************************************************************************
   * commit
   **
    * Commit the new login to the server.
    *
    * @params entity  Selected user to add to the logins.
    ***************************************************************************/
  /* @ngInject */ function commit($ctrl, Alert, BusyScreen, StoreAccountManagement) {
    return function (entity) {
      Alert.clear();
      /*------------------*/
      /* New login object */
      /*------------------*/
      var newLogin = {
        entityID: entity.id,
        name: entity.name,
        email: entity.email,
        username: entity.email
      };
      BusyScreen.promise(
        StoreAccountManagement.registerForStore(newLogin).then(
          function (added) {
            /*-----------------------------------------------*/
            /* Update the grid arrays and display success    */
            /* message upon successful addition of the login */
            /*-----------------------------------------------*/
            $ctrl.availableGrid.data.removeItem(entity);
            $ctrl.loginsGrid.data.push(newLogin);
            $ctrl.loginsGrid.data.sort(function (a, b) {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });

            Alert.success(
              entity.name +
                ' has been registered successfully and emailed their login credentials.',
              'Registration Success'
            );
          },
          function (error) {
            Alert.error(error.parsedResponse.message(), "Can't add user");

            /*-----------------------------------------------------*/
            /* Remove the email from the entity if the addition    */
            /* was unsuccessful. This is needed so the user can    */
            /* try adding the user again with a new email address. */
            /*-----------------------------------------------------*/
            entity.email = null;
          }
        )
      );
    };
  }

  /***************************************************************************
   * resetPassword
   **
    * Reset the password and send an email to the selected user.
    *
    * @params entity  Selected entity
    ***************************************************************************/
  /* @ngInject */ function resetPassword(Alert, BusyScreen, StoreAccountManagement) {
    return function (entity) {
      if (!entity) return;

      /*--------------------*/
      /* Check for an email */
      /*--------------------*/
      if (!entity.email)
        return Alert.error(
          'Email address is missing. Cannot reset the password',
          'Cannot Reset Password'
        );

      /*-----------------------------------------------------------*/
      /* Reset the password and email the entity the new password. */
      /*-----------------------------------------------------------*/
      BusyScreen.promise(
        StoreAccountManagement.resetStorePassword(entity.entityID).then(
          function (reset) {
            Alert.success(
              entity.name +
                ' has had their password reset and have been emailed a new password',
              'Password reset'
            );
          },
          function (resp) {
            Alert.error(resp.parsedResponse.message(), 'Password reset');
          }
        )
      );
    };
  }

  /***************************************************************************
   * init
   *
   * Initialize the app
   ***************************************************************************/
  /* @ngInject */ function init(
    $ctrl,
    $q,
    BusyScreen,
    StoreAccountManagement,
    uiGridConstants
  ) {
    /*------------------*/
    /* Action templates */
    /*------------------*/
    var loginCellTemplate =
      '<div class="ui-grid-cell-contents ng-binding ng-scope" style="padding-left:10px"> ' +
      '<span style="transform:scaleX(-1)" class="glyphicon glyphicon-repeat csm-grid-space-target pointer" title="Click to reset password" ng-click="grid.appScope.$ctrl.resetPassword(row.entity)"></span>' +
      '</div>';

    var addUserCellTemplate =
      '<div class="ui-grid-cell-contents ng-binding ng-scope" style="padding-left:10px"> ' +
      '<span class="glyphicon glyphicon-plus-sign csm-grid-space-target pointer" title="Register account" ng-click="grid.appScope.$ctrl.addEntity(row.entity)"></span>' +
      '</div>';

    /*-------------------*/
    /* Store logins grid */
    /*-------------------*/
    $ctrl.loginsGrid = {
      enableColumnMenus: false,
      enableColumnResizing: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableFullRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableSelectAll: false,
      saveFilter: true,
      saveSort: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        $ctrl.loginsGrid.api = gridApi;
      },
      data: [],
      columnDefs: [
        {
          field: 'name',
          displayName: 'Name'
        },
        {
          field: 'email',
          displayName: 'Email',
          cellTooltip: true
        },
        {
          field: 'username',
          displayName: 'User Name',
          cellTooltip: true
        },
        {
          cellTemplate: loginCellTemplate,
          enableColumnResizing: false,
          enableFiltering: false,
          enableSorting: false,
          field: 'actions',
          width: 40,
          displayName: ''
        }
      ]
    };

    /*----------------------*/
    /* Available users grid */
    /*----------------------*/
    $ctrl.availableGrid = {
      enableColumnMenus: false,
      enableFiltering: true,
      enableRowSelection: true,
      enableFullRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableSelectAll: false,
      saveFilter: true,
      saveSort: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        $ctrl.availableGrid.api = gridApi;
      },
      data: [],
      columnDefs: [
        {
          field: 'displayName',
          displayName: 'Available Individuals',
          cellTooltip: true
        },
        {
          cellTemplate: addUserCellTemplate,
          enableFiltering: false,
          enableSorting: false,
          field: 'actions',
          width: 40,
          displayName: ''
        }
      ]
    };

    /*------------------------------------------------------*/
    /* Get the list of logins and entities from the server. */
    /*------------------------------------------------------*/
    BusyScreen.setBusy(true);
    StoreAccountManagement.getStoreLogins().then(function (logins) {
      StoreAccountManagement.getEntityList().then(function (list) {
        /*------------------------------------------*/
        /* Create a displayName to display the name */
        /* along with the studentID in parentheses. */
        /*------------------------------------------*/
        list.forEach(function (l) {
          l.displayName = l.studentID
            ? l.name + ' (' + l.studentID + ')'
            : l.name;
        });

        /*--------------------------------------------------*/
        /* Remove the users that already have store logins. */
        /*--------------------------------------------------*/
        logins.forEach(function (login) {
          var hasLogIn = list.find(function (entity) {
            return login.entityID == entity.id;
          });
          if (hasLogIn) list.removeItem(hasLogIn);
        });

        /*---------------------*/
        /* Set the grid arrays */
        /*---------------------*/
        $ctrl.loginsGrid.data = logins;
        $ctrl.availableGrid.data = list.sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
        BusyScreen.setBusy(false);
      });
    });
  }
}
